import React, { useState } from "react";
import axios from "axios";


const useFeedbackType = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [feedbackTypeOption, setFeedbackType] = useState([])
    const mainApi = '/system/news/feedback/type'
    const getFeedbackTypeOption = (params) => {
        axios.get(mainApi, {
            params: {
                // current: 1,
                // pageSize: 20,
                // size: 20,
                // cur_page: 1,
            }
        })
            .then((response) => {
                let data = response.data?.data ||[]
                data = data.map((value) => {
                    return {
                        label: value?.feed_back_type_name,
                        value: value?.feed_back_type_id,
                        ...value
                    }
                })
                setFeedbackType(data)
            });
    }
    const getFeedbackTypeData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postFeedbackTypeData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchFeedbackTypeData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "failure") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteFeedbackTypeData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        feedbackTypeOption: feedbackTypeOption,
        feedbackTypeData: data,
        getFeedbackTypeData,
        postFeedbackTypeData,
        patchFeedbackTypeData,
        deleteFeedbackTypeData,
        getFeedbackTypeOption
    }
}
export { useFeedbackType }
